import { makeRequest } from 'services/utils';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';

const { BulkSequencesTriggerDays } = Endpoints;

const { errors: errorCopies } = strings.bulkEmails;

export const getBulkSequencesRecommendedDays = async () =>
  makeRequest({
    method: 'get',
    url: BulkSequencesTriggerDays,
    alertConfig: {
      error: {
        title: errorCopies.gettingSequencesTriggerDays
      }
    }
  });
